import { render, staticRenderFns } from "./DadosPessoais.vue?vue&type=template&id=709612ee&scoped=true&"
import script from "./DadosPessoais.vue?vue&type=script&lang=js&"
export * from "./DadosPessoais.vue?vue&type=script&lang=js&"
import style0 from "./DadosPessoais.vue?vue&type=style&index=0&id=709612ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709612ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VSelect,VTextField})
